import React from 'react'
import FormulaButton from '../formulaButton'
import DensityCorrectionForm from '../../container/densityCorrectionForm'
import { FormText } from 'reactstrap'

export default class DensityCorrectionButton extends React.Component {
    render() {
        return (
            <div>
                <FormulaButton label="Acid Density Correction" iconName="densityCorrection">
                    <DensityCorrectionForm />
                    <FormText>
                        The calculated density correction is based on a typical reference acid. Reference table is available in the “Documents” block.
                            </FormText>
                </FormulaButton>
            </div>
        )
    }
}